
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import settingsClasses from "../PlatformSetting/Settings.module.css";
import {YuJaRadioBox} from "../../components/standardization/YuJaRadiobox";
import {
    AUDIENCE_RESTRICTION,
    GRADE_SCHEMA, LMS_GRADEBOOK_SYNC,
    POLL_TYPE,
    RECORD_ATTEMPT,
    SYNC_ATTEMPT, USER_SETTINGS, YUJA_DROPDOWN_SIZE
} from "../../utils/constants";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import classes from "./ActivityEditor.module.css";
import YuJaSwitch from "../../components/standardization/YuJaSwitch";


export default function ActivityEditorConfigurationSectionB({draftActivity, setDraftActivity, userSettings, courseList, hasReleased}) {
    const {t} = useTranslation();
    const columnLayoutStyle = {width: "100%", display: "flex", flexDirection: "column"};
    const recordAttemptOptions = [
        {...RECORD_ATTEMPT.ALL, label: t(RECORD_ATTEMPT.ALL.labelKey)},
        {...RECORD_ATTEMPT.RECENT, label: t(RECORD_ATTEMPT.RECENT.labelKey)}
    ];
    const attemptSettingsArr = [
        {...LMS_GRADEBOOK_SYNC.FIRST, label: t(LMS_GRADEBOOK_SYNC.FIRST.labelKey)},
        {...LMS_GRADEBOOK_SYNC.RECENT, label: t(LMS_GRADEBOOK_SYNC.RECENT.labelKey)},
        {...LMS_GRADEBOOK_SYNC.HIGHEST, label: t(LMS_GRADEBOOK_SYNC.HIGHEST.labelKey)}
    ];

    const [maxAttempts, setMaxAttempts] = useState(!!draftActivity.attempts ? `${draftActivity.attempts}` : "-1");


    const onClickAudienceRestriction = (val) => {
        let copy = JSON.parse(JSON.stringify(draftActivity));
        copy.audienceRestriction = val;
        setDraftActivity(copy);
    }

    const handleRecordAttemptOptionClick = (value) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        if (value === RECORD_ATTEMPT.RECENT.value) {
            copy.recordAttempt = SYNC_ATTEMPT.RECENT.value;
            copy.lmsAttempt = LMS_GRADEBOOK_SYNC.RECENT.value;
        } else if (value === RECORD_ATTEMPT.ALL.value) {
            copy.recordAttempt = RECORD_ATTEMPT.ALL.value;
            copy.lmsAttempt = userSettings[USER_SETTINGS.POLL_LMS_SYNC];
        }
        setDraftActivity(copy);
    };

    const handleLMSAttemptSettingChange = (item) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.lmsAttempt = item.value;
        setDraftActivity(copy);
    };

    const onChangeMaximumAttempts = (e) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        if (e.target.checked) {
            copy.maxAttempts = -1;
        } else {
            copy.maxAttempts = 1;
        }
        setDraftActivity(copy);
    }


    const disableParticipantRestriction =
        (draftActivity.pollType === POLL_TYPE.MERGED_POLL
            && draftActivity.gradeSchema ===GRADE_SCHEMA.GRADED.key
            && !!draftActivity.syncLms)
        || (draftActivity.pollType === POLL_TYPE.ATTENDANCE && !!draftActivity.syncLms);


    return (
        <div className={classes.settingsGridLayout}>
            {!!hasReleased &&
                <div
                    style={{
                        position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                        background: "#E6E6E6", opacity: 0.5,
                        cursor: "not-allowed", zIndex: 1
                    }}
                />
            }



            {/* participant restrictions  */}
            <div style={{...columnLayoutStyle, gridColumn: "1/-1"}}>
                <div className={settingsClasses.settingLabel}>{t("gradebook.audienceRestrictionTitle")}</div>
                <div className={settingsClasses.settingDescription}>
                    {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                        ? t("gradebook.audienceRestrictionDescriptionAttendance")
                        : t("gradebook.audienceRestrictionDescriptionPoll")
                    }
                </div>

                <div style={{display: "flex", flexDirection: "column", gap: 8, marginTop: 8, position: "relative"}}>
                    <YuJaRadioBox
                        size={18}
                        labelStyle={{fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                        label={t("questionBuilder.audienceRestrictionEveryone")}
                        checked={draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.UNRESTRICTED}
                        onClick={() => onClickAudienceRestriction(AUDIENCE_RESTRICTION.UNRESTRICTED)}
                    />
                    <YuJaRadioBox
                        size={18}
                        labelStyle={{fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                        label={t("questionBuilder.audienceRestrictionName")}
                        checked={draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.NAME_REQUIRED}
                        onClick={() => onClickAudienceRestriction(AUDIENCE_RESTRICTION.NAME_REQUIRED)}
                    />
                    <YuJaRadioBox
                        size={18}
                        labelStyle={{fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                        label={t("questionBuilder.audienceRestrictionLoggedIn")}
                        checked={draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.LOGGED_IN}
                        onClick={() => onClickAudienceRestriction(AUDIENCE_RESTRICTION.LOGGED_IN)}
                    />

                    <YuJaRadioBox
                        size={18}
                        labelStyle={{fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                        label={t("questionBuilder.audienceRestrictionCourse")}
                        checked={draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED}
                        onClick={() => onClickAudienceRestriction(AUDIENCE_RESTRICTION.REGISTERED)}

                    />
                    {draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED &&

                        <YuJaDropdown
                            placeholder={t("course.selectPlaceholder")}
                            searchAble={true}
                            containerStyle={{minWidth: 200, maxWidth: 320, marginTop: 5}}
                            size={"small"}
                            data={courseList}
                            value={draftActivity.courseId}
                            onChange={option => {
                                const copy = JSON.parse(JSON.stringify(draftActivity));
                                copy.courseId = option.value;
                                setDraftActivity(copy);
                            }}
                        />
                    }

                    {!!disableParticipantRestriction && !hasReleased &&
                        <YuJaTooltip
                            tooltipStyle={{maxWidth: 350}}
                            text={t("questionBuilder.participantRestrictionDisablingReason")}
                        >
                            <div
                                style={{
                                    position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                                    background: "#E6E6E6", opacity: 0.5,
                                    cursor: "not-allowed", zIndex: 1
                                }}
                            />
                        </YuJaTooltip>
                    }
                </div>
            </div>

            {/*Attempt sync to Grade Book */}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{t("poll.gradeBookLabel")}</div>
                        <div className={settingsClasses.settingDescription}>{t("gradebook.attemptSyncToGradeBookDescription")}</div>
                    </div>

                    <YuJaDropdown
                        ariaLabel={t("accessibility.attemptDropdown") + userSettings[USER_SETTINGS.POLL_LMS_SYNC]}
                        containerStyle={{width: 250, flexShrink: 0}}
                        data={attemptSettingsArr}
                        value={draftActivity.lmsAttempt}
                        onChange={handleLMSAttemptSettingChange}
                        size={YUJA_DROPDOWN_SIZE.SMALL}
                        disabled={draftActivity.recordAttempt === SYNC_ATTEMPT.RECENT.value}
                    />
                </>
            }


            {/*Poll max Attempts*/}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{t("gradebook.pollAttemptsLabel")}</div>
                        <div className={settingsClasses.settingDescription}>{t("gradebook.unlimitedMaxAttemptsSettingText")}</div>
                    </div>

                    <YuJaSwitch
                        aria-label={t("gradebook.pollAttemptsLabel")}
                        checked={!draftActivity.maxAttempts || parseInt(draftActivity.maxAttempts) < 0}
                        onChange={checked => {
                            const copy = JSON.parse(JSON.stringify(draftActivity));
                            if (checked) {
                                copy.maxAttempts = -1;
                            } else {
                                copy.maxAttempts = 1;
                            }
                            setDraftActivity(copy);
                        }}
                    />

                    {!!draftActivity.maxAttempts && parseInt(draftActivity.maxAttempts) > 0 &&
                        <>
                            <span className={settingsClasses.settingDescription} style={{width: "100%"}}>
                                {t("questionBuilder.setMaxAttempts")}
                            </span>

                            <YuJaTextBox
                                containerStyle={{width: 50, height: 35}}
                                inputAlign={"center"}
                                value={draftActivity.maxAttempts}
                                onChange={(e) => setMaxAttempts(e.target.value)}
                                placeholder={"1"}
                                type={"number"}
                                onBlur={() => {
                                    const copy = JSON.parse(JSON.stringify(draftActivity));
                                    if (!maxAttempts) {
                                        copy.maxAttempts = -1;
                                    } else if (parseInt(maxAttempts) > 0) {
                                        copy.maxAttempts = parseInt(maxAttempts);
                                        setMaxAttempts(`${parseInt(maxAttempts)}`);
                                    }else {
                                        copy.maxAttempts = -1;
                                    }
                                    setDraftActivity(copy);
                                }}
                            />
                        </>
                    }
                </>
            }

            {/*  Record Attempts  */}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <div style={{...columnLayoutStyle, gridColumn: "1/-1"}}>
                    <span className={settingsClasses.settingLabel}> {t("gradebook.recordAttemptTitle")} </span>
                    <div style={{display: "flex", flexDirection: "column", gap: 8, marginTop: 8}}>
                        {recordAttemptOptions.map((optionData, index) => {
                            const {value, label} = optionData;
                            return (
                                <YuJaRadioBox
                                    key={index}
                                    aria-label={label + t("accessibility.radialButtonSuffix") + (value === draftActivity.recordAttempt ? "selected" : "unselected")}
                                    label={label}
                                    style={{width: "fit-content", fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                                    checked={draftActivity.recordAttempt === value}
                                    onClick={() => handleRecordAttemptOptionClick(value)}
                                />
                            );
                        })}
                    </div>
                </div>
            }

        </div>
    );
}